import CustomDatePicker from "components/common/CustomDatePicker";
import { Button, Dropdown, Menu } from "antd";
import Input from "components/common/Input";
import { DownloadOutlined } from "@ant-design/icons";
import Colors from "assets/Colors";
import SearchIcon from "components/icons/SearchIcon";
import { useTranslation } from "react-i18next";
import s from "./styles";

function TopMenu({
  loading,
  value,
  onChange,
  setSearch,
  getImageGraph,
  exportFileExcel,
  disabled,
  pagination,
  setPagination,
}) {
  const { t } = useTranslation();

  const menu = (
    <Menu style={{ padding: "8px" }}>
      <Menu.Item>
        <Button
          type="link"
          icon={<DownloadOutlined />}
          size="large"
          style={{ color: "#000" }}
          disabled={disabled}
          onClick={() => exportFileExcel()}
        >
          Excel
        </Button>
      </Menu.Item>
      <Menu.Item>
        <Button
          type="link"
          icon={<DownloadOutlined />}
          size="large"
          style={{ color: "#000" }}
          disabled={disabled}
          onClick={() => getImageGraph()}
        >
          Pdf
        </Button>
      </Menu.Item>
    </Menu>
  );

  return (
    <s.TopContainer>
      <s.ContainerDatePicker>
        <CustomDatePicker loading={loading} value={value} onChange={onChange} />
        <s.downloadButtonContainer>
          <s.Title2>
            <br />
          </s.Title2>
          <Dropdown disabled={loading} overlay={menu}>
            <Button
              style={{
                height: "40px",
                width: "40px",
                borderColor: Colors.icon_secondary,
              }}
              icon={<DownloadOutlined />}
            />
          </Dropdown>
        </s.downloadButtonContainer>

        {pagination && (
          <div>
            <s.Title>{t("containers.ReportsItems.pagination")}</s.Title>
            <s.ContainerPagination>
              <s.elemetPagination
                onClick={() => setPagination(10)}
                select={pagination === 10}
              >
                10
              </s.elemetPagination>
              <s.elemetPagination
                style={{
                  borderLeft: "none",
                  borderRight: "none",
                }}
                onClick={() => setPagination(20)}
                select={pagination === 20}
              >
                20
              </s.elemetPagination>
              <s.elemetPagination
                onClick={() => setPagination(50)}
                select={pagination === 50}
              >
                50
              </s.elemetPagination>
            </s.ContainerPagination>
          </div>
        )}
      </s.ContainerDatePicker>
      {setSearch && (
        <div>
          <s.Title>{t("containers.ReportsItems.searchItem")}</s.Title>
          <Input
            disabled={loading}
            placeholder={t("containers.ReportsItems.search")}
            style={{
              marginBottom: "14px",
              maxWidth: "340px",
              minWidth: "200px",
            }}
            prefix={<SearchIcon />}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      )}
    </s.TopContainer>
  );
}

export default TopMenu;
